import React, { useState } from 'react';
import { useEffect } from 'react';
import agrest from '../assets/domek/agrest.jpg';
import './MountainsCottage.css';
import arkuszDomek from '../assets/files/arkusze/inf04Domek.pdf';

 export default function MountainsCottage() {

  const [polubCount, setPolubCount] = useState(0);  // liczba polubień
  
  const [numbers, setNumbers] = useState([]); // liczby losowe - inicjalizujemy stan jako pustą tablicę
  const [count, setCount] = useState(0);      // ilość wygenerowanych losowych liczb
  const [wartownik, setWartownik] = useState(0);  // wartownik - szukana liczba
  
  const onClickGeneruj = (count) => {  // generowanie losowych liczb
      const randomNumbers = [];
      // ograniczenie liczby losowych liczb
      if(count >= 100){
        count = 100;
      }
      for (let i = 0; i < count; i++) {
        // Generowanie losowej liczby i dodanie jej do tablicy
        randomNumbers.push(Math.floor(Math.random() * 100)); // Liczby od 0 do 99
      }
      setNumbers(randomNumbers); // Ustawiamy nowy stan
      setWartownik(-1);   // ustawiamy wartownika
  };

  const onClickPolub = () => {
    setPolubCount(polubCount + 1);
  };

  const onClickUsun = () => {
    if(polubCount !== 0){
      setPolubCount(polubCount - 1);
    }
  };

  const onClickZapisz = () => {
    const data = `${polubCount} polubień`;
    //Używamy Blob, aby stworzyć obiekt reprezentujący dane, które chcemy zapisać. 
    // W tym przypadku tworzony jest plik tekstowy.
    const blob = new Blob([data], { type: 'text/plain' });
    // URL.createObjectURL(blob) tworzy URL do obiektu Blob, 
    // który można użyć jako link do pobrania
    const url = URL.createObjectURL(blob);
    // Tworzymy element <a> i ustawiamy jego atrybuty href i download, 
    // następnie symulujemy kliknięcie na ten link
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = 'polubienia.txt';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url); // Zwolnienie URL
};


// algorytm przeszukania tablicy z wartownikiem
useEffect(() => {
  let liczby = numbers.slice();   // kopia tablicy numbers
  // reset koloru (zostawał czerwony po znalezieniu liczby w tablicy)
  for (let k = 0; k < liczby.length; k++) {
      const element = document.getElementById('span' + k);
      element.style.color = '#808080'; // Zmiana koloru tekstu
  }
  
    liczby.push(wartownik);
    let index = 0;
    for (let i = 0; i < liczby.length; i++) {
      if (liczby[i] === liczby[liczby.length-1]){
          index = i;
          break;
      } 
    }
    if (index !== liczby.length-1){
      const element = document.getElementById('span' + index);
      element.style.color = 'red'; // Zmiana koloru tekstu
    }
  
}, [numbers, wartownik]);


  return (
    <div id="domek-container">
      <div id="domek-header">
        Domek w górach
      </div>
      <img src={agrest} width="100%" alt="agrest"/>
      <div>
        <button className="domek-button" onClick={onClickPolub}>POLUB</button>
        <button className="domek-button" onClick={onClickUsun}>USUŃ</button>
        {/*Po naciśnięciu przycisku ZAPISZ, plik polubienia.txt zostanie pobrany na lokalny dysk użytkownika*/}
        <button className="domek-button" onClick={onClickZapisz}>ZAPISZ</button>
      </div>
      <div id="domek-info">
        {polubCount} polubień
      </div>
      <hr id="domek-hr" />
      <div id="domek-opis">
        <p id="domek-opis-bold">Opis</p>
        Odwiedź komfortowy domek w Sudetach, blisko do szlaków turystycznych.
      </div>
      <hr />
      <div>
      <h1>algorytm przeszukiwania tablicy z wartownikiem</h1>
      <input
        type="number"
        value={count}
        onChange={(e) => setCount(Number(e.target.value))} // liczba wygenerowanych liczb
      />
      <button onClick={() => onClickGeneruj(count)}>Generuj losowe liczby (do 100)</button>
      <br /><br />
      <input
        type="number"
        value={wartownik}
        onChange={(e) => setWartownik(Number(e.target.value))} // wartownik - poszukiwana liczba
      /><span>wartownik - poszukiwana liczba</span>
      
      <h2>Do wygenerowanych liczb dokładamy na końcu wartownika:</h2>
      {numbers.length > 0 ? ( // Sprawdzamy, czy są liczby do wyświetlenia
        <div>
          {numbers.map((number, index) => (
            <span key={index} id={`span${index}`}>{number}   </span> // Wyświetlamy wygenerowane losowe liczby
          ))}
          <span id="domek-wartownik">{wartownik}</span>
        </div>
      ) : (
        <p>Nie wygenerowano jeszcze żadnych liczb.</p> // Komunikat, gdy nie ma wygenerowanych liczb
      )}
      <br />
      </div>
      <div>
        <a href={arkuszDomek}>arkusz Domek w górach</a>
      </div>
      <br />
    </div>
  );
}


